<template>
  <hm-content>
    <div>
      <div class="title">
        基础信息
      </div>
      <el-form
        :model="ruleData"
        :rules="rules"
        ref="addAgent"
        label-width="120px"
      >
        <el-form-item label="代理商名称" prop="storeName">
          <el-input
            v-model="ruleData.storeName"
            placeholder="请输入代理商名称"
            clearable
            size="small"
          ></el-input>
          <div class="ml10" style="color: #909399; font-size: 14px">
            代理商名称与营业执照一致
          </div>
        </el-form-item>
        <el-form-item label="基础分成比例" size="small" prop="profitRatio">
          <el-input
            v-model="ruleData.profitRatio"
            type="number"
            size="small"
            placeholder="请输入基础分成比例"
            clearable
          ></el-input
          ><span class="ml10">%</span>
          <div class="ml10" style="color: #909399; font-size: 14px">
            从平台利润中分给代理商的收益，计算公式为每笔平台收入*分成比例
          </div>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="ruleData.serviceType">
            <el-radio :label="'enterprise'">企业</el-radio>
            <el-radio :label="'personage'">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="title mt20">
          认证信息
        </div>
        <el-form-item
          label="营业执照"
          prop="licenseImg"
          class="mt20"
          v-if="ruleData.serviceType == 'enterprise'"
        >
          <div v-if="ruleData.licenseImg" class="flex">
            <div class="mr10 flex item-end priview">
              <el-image
                class="img"
                style="width: 106px; height: 106px"
                :src="ruleData.licenseImg"
                alt="logo"
                :preview-src-list="[ruleData.licenseImg]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove('licenseImg')"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            ref="upload"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onError="uploadError"
            :onSuccess="licenseUploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传营业执照</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="简称"
          size="small"
          prop="businessLicense"
          v-if="ruleData.serviceType == 'enterprise'"
        >
          <el-input
            v-model="ruleData.businessLicense"
            size="small"
            placeholder="请输入企业简称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="社会信用代码"
          size="small"
          prop="industryCode"
          v-if="ruleData.serviceType == 'enterprise'"
        >
          <el-input
            v-model="ruleData.industryCode"
            size="small"
            placeholder="请输入社会信用代码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="经营期限"
          size="small"
          prop="licenseDate"
          v-if="ruleData.serviceType == 'enterprise'"
        >
          <el-date-picker
            v-model="ruleData.licenseDate"
            clearable
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份证正面" prop="idcardFrontImg">
          <div v-if="ruleData.idcardFrontImg" class="flex">
            <div class="mr10 flex item-end priview">
              <el-image
                class="img"
                style="width: 106px; height: 106px"
                :src="ruleData.idcardFrontImg"
                alt="logo"
                :preview-src-list="[ruleData.idcardFrontImg]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove('idcardFrontImg')"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            ref="upload"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onError="uploadError"
            :onSuccess="cropUploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传国徽面</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="身份证反面" prop="idcardBackImg">
          <div v-if="ruleData.idcardBackImg" class="flex">
            <div class="mr10 flex item-end priview">
              <el-image
                class="img"
                style="width: 106px; height: 106px"
                :src="ruleData.idcardBackImg"
                alt="logo"
                :preview-src-list="[ruleData.idcardBackImg]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove('idcardBackImg')"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            ref="upload"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onError="uploadError"
            :onSuccess="backIdCardUploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传人像面</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="授权书" prop="authBookImg">
          <div v-if="ruleData.authBookImg" class="flex">
            <div class="mr10 flex item-end priview">
              <el-image
                class="img"
                style="width: 106px; height: 106px"
                :src="ruleData.authBookImg"
                alt="logo"
                :preview-src-list="[ruleData.authBookImg]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove('authBookImg')"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            ref="upload"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onError="uploadError"
            :onSuccess="authorizationUploadSuccess"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传授权书</span>
              </div>
            </div>
            <div class="el-upload__tip flex flex-column flex-end" slot="tip">
              <span>
                请<span class="blue">下载授权书模板</span>后让用户签订上传
              </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="idcardName" size="small">
          <el-input
            v-model="ruleData.idcardName"
            size="small"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="证件号码" prop="idcardNo">
          <el-input
            v-model="ruleData.idcardNo"
            size="small"
            placeholder="请输入证件号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="证件有效期" prop="idcardDate">
          <el-date-picker
            v-model="ruleData.idcardDate"
            clearable
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactPhone">
          <el-input
            v-model="ruleData.contactPhone"
            size="small"
            placeholder="请输入联系人手机号"
            clearable
          ></el-input>
          <div class="ml10" style="color: #909399; font-size: 14px">
            提交成功后自动以该手机号创建该代理商员工,员工可直接在小程序登录
          </div>
        </el-form-item>
        <el-form-item label="邮箱号" prop="contactEmail">
          <el-input
            v-model="ruleData.contactEmail"
            type="email"
            size="small"
            placeholder="请输入邮箱号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="所属区域" prop="resource">
          <el-cascader
            :options="area"
            size="small"
            ref="citys"
            clearable
            placeholder="请选择所属区域"
            v-model="ruleData.citys"
            :props="props"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="storeAddress">
          <el-input
            v-model="ruleData.storeAddress"
            size="small"
            placeholder="请输入详细地址"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="合作时间" prop="resource">
          <el-date-picker
            v-model="ruleData.hzTime"
            clearable
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="渠道经理" prop="resource">
          <el-input
            v-model="ruleData.name"
            size="small"
            placeholder="请输入渠道经理"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex flex-center item-center mt40">
      <el-button type="primary" size="small" @click="submit"> 确认</el-button>
      <el-button type="info" size="small"> 取消</el-button>
    </div>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
export default {
  data() {
    return {
      ruleData: {
        idcardFrontImg: "",
        serviceType: "enterprise",
        licenseImg: "",
        authBookImg: "",
        idcardBackImg: "",
        licenseDate: "",
        idcardDate: "",
        hzTime: "",
        licenseDueMode: "false",
        licenseDueDate: "", //营业执照到期日
        idcardStartDate: "", //身份证有效开始时间
        idcardEndDate: "", //身份证有效结束时间
        storeProvince: "", //省
        storeCity: "", //市
        storeDistrict: "", //区
        cooperativeStartDay: "", //合作开始时间
        cooperativeStartEnd: "" //合作结束时间
      },
      rules: {
        storeName: [
          { required: true, message: "请输入代理商名称", trigger: "blur" }
        ],
        profitRatio: [
          { required: true, message: "请输入基础分成比例", trigger: "blur" }
        ],
        serviceType: [
          { required: true, message: "请选择类型", trigger: "change" }
        ],
        licenseImg: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ],
        businessLicense: [
          { required: true, message: "请输入企业简称", trigger: "blur" }
        ],
        industryCode: [
          { required: true, message: "请输入社会信用代码", trigger: "blur" }
        ],
        licenseDate: [
          { required: true, message: "请选择经营期限", trigger: "change" }
        ],
        idcardFrontImg: [
          { required: true, message: "请上传身份证正面", trigger: "change" }
        ],
        idcardBackImg: [
          { required: true, message: "请上传身份证反面", trigger: "change" }
        ],
        idcardName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        idcardNo: [
          { required: true, message: "请输入证件号码", trigger: "blur" }
        ],
        idcardDate: [
          { required: true, message: "请选择证件有效期", trigger: "change" }
        ],
        contactPhone: [
          { required: true, message: "请输入联系人手机号", trigger: "blur" }
        ],
        contactEmail: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ]
      },
      area,
      props: {
        value: "value",
        children: "children"
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    //路由跳转
    toUrl(url) {
      this.$router.push({
        name: url
      });
    },
    //提交数据
    submit() {
      this.$refs.addAgent.validate(valid => {
        if (valid) {
          this.ruleData.contactName = this.ruleData.idcardName;
          if (this.ruleData.citys && this.ruleData.citys.length > 0) {
            this.ruleData.storeProvince = this.ruleData.citys[0];
            this.ruleData.storeCity = this.ruleData.citys[1];
            this.ruleData.storeDistrict = this.ruleData.citys[2];
          }
          if (
            this.ruleData.licenseDate &&
            this.ruleData.licenseDate.length > 0
          ) {
            this.ruleData.licenseDueDate = this.ruleData.licenseDate[1];
          }
          if (this.ruleData.idcardDate && this.ruleData.idcardDate.length > 0) {
            this.ruleData.idcardStartDate = this.ruleData.idcardDate[0];
            this.ruleData.idcardEndDate = this.ruleData.idcardDate[1];
          }
          if (this.ruleData.hzTime && this.ruleData.hzTime.length > 0) {
            this.ruleData.cooperativeStartDay = this.ruleData.hzTime[0];
            this.ruleData.cooperativeStartEnd = this.ruleData.hzTime[1];
          }
          let params = this.ruleData;
          this.$store.dispatch("redPackageAddAgent", params).then(res => {
            console.log("res===", res);
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.toUrl("RedPackageAgentManage");
            }
          });
        }
      });
    },
    //判断是否为数组
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleData[spreadBgp] = "";
    },
    licenseUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleData.licenseImg = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleData.idcardFrontImg = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    backIdCardUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleData.idcardBackImg = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    authorizationUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleData.authBookImg = jsonData.result;
        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 正在上传
    uploading() {
      //   this.isSaving = true;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      //   this.isSaving = false;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    margin-left: 0;
    // padding: 10px;
    margin-right: 10px;
    width: 106px;
    height: 106px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  width: 106px;
  height: 106px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
